const DUMMY_IMAGE_URL =
  'https://s3.amazonaws.com/cdn-portraitpics/products/2/2018-spring/gallery-image-placeholder.png';

export { DUMMY_IMAGE_URL };
